export default __webpack_public_path__ + "static/media/services-icon.485d046d.svg";